var pa1 = "/static/4cad1068d0b0b5da.png";

export { pa1 as default };
//# sourceMappingURL=pa_1.png.js.map
